import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserContextEnum, UserContextService } from '../../core/services/user-context.service';

@Directive({
  selector: 'img[appLogo]'
})
export class LogoDirective implements OnInit, OnDestroy {
  private readonly COACHEE_LOGO_URL = '/assets/images/fac/logo-coachee.png';
  private readonly COACH_LOGO_URL = '/assets/images/fac/logo-coach.png';

  private subscription?: Subscription;

  constructor(
    private readonly el: ElementRef<HTMLImageElement>,
    private readonly renderer: Renderer2,
    private readonly userContextService: UserContextService
  ) {}

  ngOnInit(): void {
    this.subscription = this.userContextService.userContext$.subscribe((context) => {
      const logoUrl = context === UserContextEnum.Coach ? this.COACH_LOGO_URL : this.COACHEE_LOGO_URL;
      this.renderer.setAttribute(this.el.nativeElement, 'src', logoUrl);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
